import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { RecentSearchDataType } from '@design-system/components/molecules/recent-search/entities/recent-search.types';
import { TypographyFontFamily, TypographyFontSize } from '@design-system/components/atoms/typography/entities/typography.types';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { TooltipDsDirective } from '@design-system/components/templates/tooltip/directives/tooltip.directive';

@Component({
  selector: 'app-ds-recent-search',
  templateUrl: './recent-search.component.html',
  styleUrls: ['./recent-search.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    IconDsComponent,
    TypographyDsComponent,
    TooltipDsDirective,
  ],
})
export class RecentSearchDsComponent {

  @Input() dataType: RecentSearchDataType = RecentSearchDataType.Flight;
  @Input() from: string;
  @Input() to: string;
  @Input() destination: string;
  @Input() isOneWay: boolean;
  @Input() startDate: string;
  @Input() endDate: string;
  @Input() paxNumber: number;
  @Input() roomNumber: number;
  @Input() tooltipText: string;
  @Input() activateTooltip: boolean;

  @Output() clicked: EventEmitter<void> = new EventEmitter<void>();

  public readonly iconSize = 24;

  public readonly iconColor = IconFillColor.Primary;

  constructor() { }

  get icon(): Icon {
    switch (this.dataType) {
      case RecentSearchDataType.Flight:
        return Icon.Flights;
      case RecentSearchDataType.Hotel:
        return Icon.Hotels;
      case RecentSearchDataType.ByHours:
        return Icon.ByHours;
      case RecentSearchDataType.Packages:
        return Icon.Packages;
      case RecentSearchDataType.Cars:
        return Icon.Autos;
      case RecentSearchDataType.Bus:
        return Icon.Buses;
      default:
        return null;
    }
  }

  get flightTripIcon(): Icon {
    return this.isOneWay ? Icon.ArrowRight : Icon.Roundtrip;
  }

  get recentSearchDataType(): typeof RecentSearchDataType {
    return RecentSearchDataType;
  }

  get icons(): typeof Icon {
    return Icon;
  }

  get fontSize(): typeof TypographyFontSize {
    return TypographyFontSize;
  }

  get fontFamily(): typeof TypographyFontFamily {
    return TypographyFontFamily;
  }

  get tripDates(): string {
    return (this.dataType === RecentSearchDataType.Flight || this.dataType === RecentSearchDataType.Bus) && this.isOneWay ?
      this.startDate : `${this.startDate} - ${this.endDate}`;
  }

}
